import { useEffect } from 'react';

const SITE = 'Cynopsis';

export const usePageTitle = (title) => {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} | ${SITE}` : SITE;
    return () => {
      document.title = previous;
    };
  }, [title]);
};

export default usePageTitle;
